import { StyleSheet } from 'react-native'
import STYLES from '../../constants/styles'

export default StyleSheet.create({
    container: {
        ...StyleSheet.absoluteFillObject
        , backgroundColor: STYLES.BACKGROUND_COLOR
        , justifyContent: 'center'
        , alignItems: 'center'
        , padding: 10
        , borderRadius: 25
    },
    back: {
        position: 'absolute'
        , top: 20
        , left: 20
    },
    close: {
        position: 'absolute'
        , top: 20
        , right: 20
    },
    closeText: {
        fontSize: 18
        , fontWeight: 'bold'
        , color: STYLES.SECONDARY_TEXT_COLOR
    },
    hr: {
        width: '85%'
        , borderBottomColor: STYLES.PRIMARY_TEXT_ALPHA_COLOR
        , borderBottomWidth: 1
    },
    headerView: {
        flex: 1
        , justifyContent: 'center'
        , alignItems: 'center'
        , alignSelf: 'stretch'
    },
    header: {
        fontSize: 20
        , fontWeight: 'bold'
        , color: STYLES.SECONDARY_TEXT_COLOR
        , marginBottom: 20
    },
    subheader: {
        fontSize: 16
        , fontWeight: 'bold'
        , color: STYLES.SECONDARY_TEXT_COLOR
        , marginTop: 20
    },
    weeklyView: {
        flex: 3
        , alignSelf: 'stretch'
    },
    weeklyViewPeriod: {
        flex: 1
        , flexDirection: 'column'
        , justifyContent: 'space-around'
        , marginBottom: 30
    },
    weeklyText: {
        fontSize: 20
        , fontWeight: 'bold'
        , color: STYLES.SECONDARY_TEXT_COLOR
    },
    column1: {
        borderRightColor: STYLES.PRIMARY_TEXT_ALPHA_COLOR
        , borderRightWidth: 1
        , width: '50%'
        , paddingTop: 5
        , paddingBottom: 5
        , flexDirection: 'column'
        , justifyContent: 'center'
        , alignItems: 'center'
    },
    column2: {
        width: '50%'
        , paddingTop: 5
        , paddingBottom: 5
        , flexDirection: 'column'
        , justifyContent: 'center'
        , alignItems: 'center'
    },
    rows1: {
        paddingBottom: 20
        , flexDirection: 'column'
        , justifyContent: 'center'
        , alignItems: 'center'
    },
    rows2: {
        borderTopColor: STYLES.PRIMARY_TEXT_ALPHA_COLOR
        , paddingTop: 20
        , paddingBottom: 20
        , borderTopWidth: 1
        , flexDirection: 'row'
        , justifyContent: 'center'
        , alignItems: 'center'
    },
    rowValueTxt: {
        fontSize: 22
        , fontWeight: 'bold'
        , color: STYLES.TRANS_NEW_COLOR
    },
    rowTotalTxt: {
        fontSize: 13
        , color: STYLES.SECONDARY_TEXT_COLOR
    },
    dotNew: {
        backgroundColor: STYLES.TRANS_NEW_COLOR
        , width: 8
        , height: 8
        , borderRadius: 4
        , marginRight: 4
        , marginTop: 3
        , marginBottom: 3
    },
    dotRecurring: {
        backgroundColor: STYLES.TRANS_RECURRING_COLOR
        , width: 8
        , height: 8
        , borderRadius: 4
        , marginRight: 4
        , marginTop: 3
        , marginBottom: 3
    },
    byline: {
    },
    bylineTxt: {
        fontSize: 14
        , fontWeight: 'bold'
        , color: STYLES.SECONDARY_TEXT_COLOR
        , marginBottom: 4
    },
    byline2Txt: {
        fontSize: 12
        , color: STYLES.SECONDARY_TEXT_COLOR
    }
})



// WEBPACK FOOTER //
// ./src/components/weekly/styles.js